import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import {
  MatSlideToggleChange,
  MatSlideToggleModule,
} from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table';
import { Subject } from 'rxjs';
import { CashRegister } from 'src/app/graphql/types';
import { LoadingModule } from 'src/app/main/pages/generals/loading/loading.module';
import { CashRegisterService } from 'src/app/main/pages/services/cash-register.service';
import { PointEmissionJson } from 'src/app/main/pages/services/microservices/json/point-emission.json';
import { NumerosUtils } from 'src/app/shared';

import { CashRegisterDialogComponent } from '../../dialogs/cash-register-dialog/cash-register-dialog.component';

@Component({
  selector: 'point-emission',
  standalone: true,
  templateUrl: './point-emission.component.html',
  styleUrls: ['./point-emission.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FlexLayoutModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    LoadingModule,
    MatSlideToggleModule,
  ],
})
export class PointEmissionComponent implements OnInit, OnDestroy {
  @Input() businessUnitId = 0;
  @Output() isActiveBtn = new EventEmitter<boolean>();
  @ViewChild(MatTable, { static: true }) table?: MatTable<PointEmissionJson>;

  readonly dialog = inject(MatDialog);
  private fb = inject(FormBuilder);
  private service = inject(CashRegisterService);
  private _snackBar = inject(MatSnackBar);
  private _unsubscribeAll!: Subject<any>;
  public dataSource?: MatTableDataSource<PointEmissionJson>;

  notification: any = {};
  displayedColumns: string[] = [
    'action',
    'cashRegisterNumber',
    'cashRegisterName',
    'user',
    'creationDate',
    'active',
  ];
  ngOnInit(): void {
    this._unsubscribeAll = new Subject<any>();
  }

  public loadPointEmission(): void {
    this.service.getToPointEmission(this.businessUnitId).subscribe(data => {
      if (data) {
        this.dataSource = new MatTableDataSource(this.objectToArray(data));
        if (this.dataSource?.data.length > 0) {
          this.isActiveBtn.emit(true);
        } else {
          this.isActiveBtn.emit(false);
        }
      } else {
        this.isActiveBtn.emit(false);
      }
    });
  }

  editPointEmission(cashRegisterId: number, index: number): void {
    const dialogRef = this.dialog.open(CashRegisterDialogComponent, {
      height: '550px',
      width: '335px',
      autoFocus: false,
      data: {
        cashRegisterId,
        businessUnitId: this.businessUnitId,
      },
    });

    dialogRef.afterClosed().subscribe((cashRegisterId: number) => {
      this.loadPointEmission();
    });
  }

  switchActive(id: number, index: number, $event: MatSlideToggleChange): void {
    const form = this.fb.group({
      id,
      active: $event.checked,
    });
    this.service.update(form).subscribe(data => {
      const active = data ? $event.checked : !$event.checked;
      this.dataSource!.data![index].active = active;
    });
  }

  private objectToArray(objects: any): Array<PointEmissionJson> {
    const array: [] = JSON.parse(JSON.stringify(objects));
    const json: Array<PointEmissionJson> = [];
    array.forEach(object => {
      json.push(this.objectToJson(object));
    });
    return json!;
  }

  private objectToJson(object: CashRegister): PointEmissionJson {
    const number = NumerosUtils.addZero(Number(object.number));
    const json: PointEmissionJson = {
      id: object.id?.toString()!,
      name: object.name?.toString()!,
      number,
      user: object.user?.name!,
      active: object.active!,
      creationDate: object.creationDate?.toString()!,
    };
    return json;
  }

  private openSnack(message: string): void {
    this._snackBar.open(message, '', {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      panelClass: ['snack-error'],
      duration: 5000,
    });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(void 0);
    this._unsubscribeAll.complete();
  }
}
